module.exports = __webpack_public_path__ + "img/project_3.d13fe5b2.jpg";